import _ from 'lodash';
import cacPalette from './cacPalette';

const useChartLegend = (
  cPaletteName,
  rPaletteName,
  colorToggle,
  setColorToggle) => {
  const toggleStateEnabled = quarter => {
    switch (quarter) {
      case 0: setColorToggle(() => {
        return { ...colorToggle, zeroTo25: !colorToggle.zeroTo25 };
      }); break;
      case 26: setColorToggle(() => {
        return { ...colorToggle, twentySixTo50: !colorToggle.twentySixTo50 };
      }); break;
      case 51: setColorToggle(() => {
        return { ...colorToggle, fiftyOneTo75: !colorToggle.fiftyOneTo75 };
      }); break;
      case 76: setColorToggle(() => {
        return { ...colorToggle, seventySixTo100: !colorToggle.seventySixTo100 };
      }); break;
      default: break;
    }
  };

  const getStateEnabled = quarter => {
    return {
      0: colorToggle.zeroTo25,
      26: colorToggle.twentySixTo50,
      51: colorToggle.fiftyOneTo75,
      76: colorToggle.seventySixTo100,
    }[quarter];
  };

  // BUILD COLORS FROM A SINGLE COLOR
  // const colorLuminance = (hex, lum) => {
  //   // validate hex string
  //   hex = String(hex).replace(/[^0-9a-f]/gi, '');
  //   if (hex.length < 6) {
  //     hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  //   }
  //   lum = lum || 0;

  //   // convert to decimal and change luminosity
  //   let rgb = '#';
  //   let c;
  //   let i;
  //   for (i = 0; i < 3; i += 1) {
  //     c = parseInt(hex.substr(i * 2, 2), 16);
  //     c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
  //     rgb += ('00' + c).substr(c.length);
  //   }

  //   return rgb;
  // };

  const buildLegendBlock = (svg, index, txt, x, cPalette, rPalette) => {
    const grp = svg.append('g')
      .attr('class', 'legendBlock')
      .on('click', () => { toggleStateEnabled(index); });

    grp
      .append('rect')
      .attr('class', 'legendBlockRect')
      .attr('x', x)
      .attr('y', 3)
      .attr('width', 15)
      .attr('height', 14)
      .attr('cursor', 'pointer')
      .attr('fill', getStateEnabled(index) ? cPalette : '#CCCCCC');
    grp
      .append('rect')
      .attr('class', 'legendBlockRect')
      .attr('x', x + 15)
      .attr('y', 3)
      .attr('width', 15)
      .attr('height', 14)
      .attr('cursor', 'pointer')
      .attr('fill', getStateEnabled(index) ? rPalette : '#CCCCCC');

    grp
      .append('text')
      .attr('class', 'legendBlockText')
      .text(txt)
      .attr('font-size', '8px')
      .attr('font-weight', 100)
      .attr('font-family', 'Open Sans')
      .attr('x', x)
      .attr('y', 0)
      .attr('stroke', 'black')
      .attr('stroke-width', 0.5);
  };

  const clearChartLegend = svg => {
    svg.selectAll('.legendBlock').remove();
    svg.selectAll('.legendLine').remove();
    svg.selectAll('.legendBaseText').remove();
  };

  const buildChartLegend = (svg, xPos, yPos) => {
    clearChartLegend(svg);
    svg.attr('transform', `translate(${xPos}, ${yPos})`);

    const palettes = cacPalette();
    const cPalette = _.find(palettes, { name: cPaletteName });
    const rPalette = _.find(palettes, { name: rPaletteName });

    buildLegendBlock(svg, 0, '0-25%', 0, cPalette.pale, rPalette.pale);
    buildLegendBlock(svg, 26, '26-50%', 40, cPalette.light, rPalette.light);
    buildLegendBlock(svg, 51, '51-75%', 80, cPalette.medium, rPalette.medium);
    buildLegendBlock(svg, 76, '76-100%', 120, cPalette.dark, rPalette.dark);

    svg
      .append('line')
      .attr('class', 'legendLine')
      .attr('x1', 0)
      .attr('y1', 18)
      .attr('x2', 150)
      .attr('y2', 18)
      .attr('stroke', 'black')
      .attr('stroke-width', 1.5)
      .attr('opacity', 1);

    svg
      .append('text')
      .attr('class', 'legendBaseText')
      .text('Contribution Score')
      .attr('x', 150)
      .attr('y', 30)
      .attr('width', 150)
      .attr('text-anchor', 'end')
      .attr('font-size', '10px')
      .attr('font-weight', 100)
      .attr('font-family', 'Open Sans')
      .attr('stroke', 'black')
      .attr('stroke-width', 0.6)
      .attr('opacity', 1);

    return svg;
  };

  return [buildChartLegend, clearChartLegend];
};

export default useChartLegend;
